import React, { ChangeEvent, useEffect, useState } from "react";
import OrderCountHistogram from "./OrderCountHistogram";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import { useGetEnumsQuery } from "../../../../app/globalApi";
import { useGetAllRegularCustomersQuery } from "../../../../features/customer/customerApi";
import AutomatedOrderHistogram from "./AutomatedOrderHistogram";
import SelectField from "../../form/SelectField";
import { createOptionListForSelectTag } from "../../../../helpers/utils/Utils";
import { OptionType } from "../../../../helpers/utils/StyleUtils";
import InputField from "../../form/InputField";
import ButtonTray from "../../form/ButtonTray";
import { useUtilDataQuery } from "../../../../features/profile/profileApi";

// Ensure to import RootState type

interface BarSearchPerimeters {
    customerId: string | null;
    period: string | null;
    creationDateFrom: string | null;
    creationDateTo: string | null;
    isPageLoad?: boolean;
}

export const AutomatedOrderHistogramSearchForm: React.FC = () => {

    const customerData = useGetAllRegularCustomersQuery("");
    const defaultPeriod = "Months";
    const searchParamsData = localStorage.getItem("automatedOrderHistogramSearchParams");
    const { data: enums } = useGetEnumsQuery("");
    const [period, setPeriod] = useState<any>(null);
    const [customerId, setCustomerId] = useState<string | null>(null);
    const [creationDateFrom, setCreationDateFrom] = useState<string | null>(null);
    const [creationDateTo, setCreationDateTo] = useState<string | null>(null);
    const [applySearch, setApplySearch] = useState<boolean>(false);
    const [applyExport, setApplyExport] = useState<boolean>(false);
    const [showHideSearchForm, setShowHideSearchForm] = useState<boolean>(false);
    const { data: utilData } = useUtilDataQuery("");
    const [barSearchPerimeters, setBarSearchPerimeters] = useState<BarSearchPerimeters>({
        customerId: null,
        period: null,
        creationDateFrom: null,
        creationDateTo: null,
        isPageLoad: true,
    });



    useEffect(() => {
        const parsedSearchParams = searchParamsData ? JSON.parse(searchParamsData) : null;
        const customerId =
            utilData?.customerLevel === "CUSTOMER"
                ? utilData?.customer_Id
                : parsedSearchParams?.customerId || null;
        setCustomerId(customerId);
        setPeriod({ value: defaultPeriod?.toUpperCase(), label: defaultPeriod });
        setCreationDateFrom(moment(computeDefaultStartDate(defaultPeriod?.toUpperCase())).format("YYYY-MM-DD"));
        setCreationDateTo(moment(computeDefaultEndDate(defaultPeriod?.toUpperCase())).format("YYYY-MM-DD"));
        setApplySearch(true);
    }, []);

    useEffect(() => {

        if (utilData !== null && utilData !== undefined && utilData?.customerLevel !== null && utilData?.customerLevel !== '' && barSearchPerimeters.isPageLoad === false && utilData?.orderCountBarChartParams === null) {
            setApplySearch(true);
        }

    }, []);



    function computeDefaultEndDate(period: string): Date {
        const currentDate = new Date();
        return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
    }


    function computeDefaultStartDate(period: string): Date {
        const defaultDate = new Date();
        const lastDayOfPreviousMonth = new Date(defaultDate.getFullYear(), defaultDate.getMonth());
        const givenDate = new Date(lastDayOfPreviousMonth);

        if (period === 'MONTHS') {
            return new Date(new Date().getFullYear(), new Date().getMonth() - 6, 1);
        } else {
            return new Date(givenDate.getFullYear(), givenDate.getMonth(), 1);
        }
    }


    const clearForm = () => {
        initializePeriodFields();
        setCustomerId(utilData?.customerLevel === 'CUSTOMER' ? utilData?.customer_Id : null);
    }

    const initializePeriodFields = (newPeriod = defaultPeriod) => {
        if (!newPeriod) {
            newPeriod = defaultPeriod;
        }
        setPeriod({ value: newPeriod?.toUpperCase(), label: newPeriod });
        setCreationDateFrom(moment(computeDefaultStartDate(newPeriod?.toUpperCase())).format("yyyy-MM-DD").toUpperCase());
        setCreationDateTo(moment(computeDefaultEndDate(newPeriod?.toUpperCase())).format("yyyy-MM-DD").toUpperCase());
        setApplySearch(true);

    }


    const handleClick = (
        e: React.MouseEvent<HTMLButtonElement>,
        setState: React.Dispatch<React.SetStateAction<boolean>>
    ) => {
        e.preventDefault();
        setBarSearchPerimeters({
            customerId,
            period: period?.value,
            creationDateFrom,
            creationDateTo,
        });
        setState(true);
    }



    const handleOnChange = (e: ChangeEvent<HTMLInputElement> | { name: string; value: OptionType | string | null }) => {
        const { name, value } = "target" in e ? e.target : e;
        if (name === "customerId") {
            setCustomerId(value ? (typeof value === 'string' ? value : value?.value) : null);
        } else if (name === "period") {
            setPeriod(value);
        }
    };

    return (
        <>
            <div className="dashboard__bar_chart">
                <div className="pie_chart">
                    <AutomatedOrderHistogram
                        period={period?.value as string}
                        creationDateFrom={creationDateFrom ?? ""}
                        creationDateTo={creationDateTo ?? ""}
                        applySearch={applySearch}
                        setApplySearch={setApplySearch}
                        applyExport={applyExport}
                        setApplyExport={setApplyExport}
                        enums={enums?.["ProductType"]}
                        customerId={customerId}
                    />
                </div>
            </div>

            <i
                className="fas fa-cog fa-icon-color cursor_hover mb-3 text-highlight-0"
                onClick={() => setShowHideSearchForm(!showHideSearchForm)}
                title={showHideSearchForm ? "Hide search form" : "Show search form"}
            />

            {showHideSearchForm && (
                <div>
                    <div className="flex gap-4 justify-between">
                        <div className={"w-full"}>
                            <SelectField
                                placeholder='Select customer...'
                                value={
                                    customerId
                                        ? createOptionListForSelectTag(customerData?.data, "customerName", "customerName")
                                            ?.find(option => option.value === customerId)
                                        : ""
                                }
                                options={createOptionListForSelectTag(customerData?.data, "customerName", "id")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "customerId", value: selectedOption?.value });
                                }}
                                label={"Customer"}
                                labelPosition={"top"}
                            />
                        </div>
                        <div className={"w-full"}>
                            <SelectField
                                placeholder='Select Period...'
                                value={period}
                                options={createOptionListForSelectTag(enums?.["Period"], "value", "constant")}
                                onChange={(selectedOption) => {
                                    handleOnChange({ name: "period", value: selectedOption })
                                }}
                                label={"Period"}
                                labelPosition={"top"}
                                className={"w-full"}
                            />
                        </div>
                        <div className={"w-full"}>

                            <InputField
                                label="Created Date - From"
                                name="creationDateFrom"
                                value={creationDateFrom || ""}
                                type="date"
                                onChange={(e) => setCreationDateFrom(e.target.value)}
                                className="mb-2 w-full py-2 px-3 text-lg"
                                labelPosition="top"
                            />
                        </div>
                        <div className={"w-full"}>
                            <InputField
                                label="Created Date - To"
                                name="creationDateTo"
                                value={creationDateTo || ""}
                                type="date"
                                onChange={(e) => setCreationDateTo(e.target.value)}
                                className="mb-2 w-full py-2 px-3 text-lg"
                                labelPosition="top"

                            />
                        </div>
                    </div>
                    <div className={"align-bottom mt-3 chart_bottom"}>
                        <ButtonTray
                            buttons={[

                                {
                                    buttonProps: {
                                        btnText: "Clear",
                                        onClick: () => clearForm(),
                                        type: "close",
                                    },
                                    buttonType: "button"
                                },

                                {
                                    buttonProps: {
                                        btnText: "Apply",
                                        type: "submit",
                                        onClick: (e) => handleClick(e, setApplySearch),

                                        isLoading: (applySearch),
                                    },
                                    buttonType: "button",
                                }
                            ]}
                            align="start"
                            gap={2}
                        />
                    </div>
                </div>
            )}
        </>
    );
};
